import { Injectable } from '@angular/core';
import { StatsigClient } from '@statsig/js-client';
import { AuthService } from 'src/app/services/auth.service';
import { GateName } from 'src/app/shared/types';

@Injectable({
  providedIn: 'root'
})
export class StatsigService {
  private client: StatsigClient;
  currentUser: any;

  constructor(private authService: AuthService) {
    this.currentUser = this.authService.currentUser;
    this.initializeClient();
  }

  private async initializeClient() {
    try {
      this.client = new StatsigClient('client-CPluKFFsrQQe9QlAH24Zi1gzGVWYvMhrnMdZoQ73DoK', {
        userID: this.currentUser._id,
        email: this.currentUser.email
      });
      await this.client.initializeAsync();
    } catch (error) {
      console.error('Error initializing Statsig client', error);
    }
  }

  public async checkGate(gateName: GateName) {
    try {
      return await this.client.checkGate(gateName);
    } catch (error) {
      console.error('Error with checkGate', error);
      return null;
    }
  }
}